export default "__VITE_ASSET__ec74b16f__"